import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import GeneratorClassifier2ChoiceType from '../GeneratorClassifier2ChoiceType';

const SingleChoice1Type = ({question, items, parameters, extraFields}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <GeneratorClassifier2ChoiceType choices={question.choices} items={items} parameters={parameters} extraFields={extraFields} />
    </>
);

SingleChoice1Type.propTypes = {
    question: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    parameters: PropTypes.array,
    extraFields: PropTypes.array,
};


export default SingleChoice1Type;
